module.exports = __webpack_public_path__ + "5ae31d69edd05efd72489cb6086dad6c.MP3";